import { HttpStatusCode } from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TalkModifyPost from "../../../components/Talk/ModifyPost";
import { getTalkDetail, TalkDetail } from "../../../services/talkServices";
import { formatPostTitle } from "../../../libs/talk";

type Props = {};

// eslint-disable-next-line no-empty-pattern
export default function TalkEditPost(props: Props) {
  const params = useParams();
  const [post, setPost] = useState<TalkDetail>();

  useEffect(() => {
    if (params.id) {
      getTalkDetail(params.id).then((res) => {
        if (res.status === HttpStatusCode.Ok) {
          setPost({ ...res.data, title: formatPostTitle(res.data.title) });
        }
      });
    }
  }, [params.id]);

  return <TalkModifyPost post={post} />;
}
